

function showMainPoints(points) {
    $(".js-index-banner-tooltip").removeClass("is-loaded");

    $(".js-slider-main .swiper-slide-active .js-index-banner-tooltip").each(function (i) {
        var $point = $(this);

        setTimeout(function () {
            $point.addClass("is-loaded");
        }, i * 100);
    });
}

export const indexBannerSliderOptions = (instance, options, labels) => {
    // if one slide, disable autoplay because main points are still re-rendering
    const container = $(instance);
    const slidesCount = container.find('.swiper-slide').length;

    return {
        slidesPerView: 1,
        slidesPerGroup: 1,
        cssMode: false,
        autoplay: slidesCount > 1 ? {
            delay: 4000,
            pauseOnMouseEnter: true
        } : false,
        loop: slidesCount > 1,
        autoHeight: true,
        effect: 'fade',
        on: {
            init: function () {
                showMainPoints();
            },
            slideChangeTransitionEnd: function() {
                showMainPoints();
            }
        },
        pagination: {
            el: instance.paginationEl,
            clickable: true,
            hideOnClick: false,
            renderBullet: function (index, className) {
                
                const isMobile = window.innerWidth <= 1023;
                const content = isMobile 
                    ? (index + 1).toString().padStart(2, '0')
                    : labels[index]; 

                return `
                    <div class="${className}">
                        <div class="swiper-bullet-content">
                            ${content}
                        </div>
                    </div>`;
            }
        },
    }
}